interface PrepareOfferDataForDiscountReturnParams {
    productHasNoOffers: boolean;
    discount: number;
    minPrice30Days: number;
    price: number;
    offersCount: number;
    prevPrice: number;
    showDiscount: boolean;
    dealerName: string;
}

export function prepareOfferDataForDiscount(
    productMinPrice: number,
    productPrevPrice: number,
    offerItems: {
        price: number;
        minPrice30Days?: number | null;
        prevPrice?: number | null;
        discount?: number;
        dealer: {
            name: string;
        };
    }[],
    offersCount: number
): PrepareOfferDataForDiscountReturnParams {
    const productHasNoOffers = offersCount === 0;
    let discount = 0;
    let minPrice30Days = 0;
    let prevPrice = 0;
    let price = productMinPrice || productPrevPrice;
    let dealerName = '';

    if (!productHasNoOffers) {
        dealerName = offerItems[0]?.dealer.name;
        discount = offerItems[0]?.discount || 0;
        minPrice30Days = offerItems[0]?.minPrice30Days || 0;
        prevPrice = offerItems[0]?.prevPrice || minPrice30Days || 0;
        price = offerItems[0]?.price || price;
    }

    const showDiscount = minPrice30Days > 0 && !productHasNoOffers;

    return { productHasNoOffers, discount, minPrice30Days, price, offersCount, prevPrice, showDiscount, dealerName };
}
